import React, { useState, useEffect } from "react";
import { ECLCompoundInput, ECLThemeImage } from "../../index";

const ECLFilterBar = (props) => {
   //PROPS
   //id - string [optional] - if present, set an ID for the container div of the compound input
   //placeholder - string [optional] - if present, changes from "Filter" to this placeholder
   //onInput - function [required] - will fire and send current input after each key user types, also handles the empty string when user clears filter bar with 'x' button
   //class - string [optional] -  adds a class to the div element that surround the input element, used for custom styling
   //defaultValue - string [optional] - if present, will set the default value of the input
   const [input, setInput] = useState(
      props.defaultValue ? props.defaultValue : "",
   );

   useEffect(() => {
      props.onInput(input);
   }, [input]);

   return (
      <ECLCompoundInput
         id={props.id}
         icon={
            <ECLThemeImage fontAwesome="magnifying-glass" alt="Search icon" />
         }
         iconDescription="Filter"
         onChange={setInput}
         placeholder={props.placeholder ? props.placeholder : "Filter"}
         value={input}
         class={props.class}
      />
   );
};

export default ECLFilterBar;
